import { VgAPI, VgMedia, VgEvents, VgUtils } from "../../_modules/player/core";
import { Component, Injectable, EventEmitter } from "@angular/core";
import { IMedia } from "./videoplayer.imedia";
import { Subscription, fromEvent } from "rxjs";
import { videoPlayerApi } from "./videoplayer.api";
import { interstitialData, intersitialEvent } from "./videplayer.interstitialData";
import { playerUtil } from "./videoplayer.utils";
import { Utility } from "../../_service/utility";

@Injectable()

/**
* 播放器API
*/
export class videoPlayerVgApi implements videoPlayerApi {

    setVolume(val: any) {
        (<VgMedia>this.vgAPI.getDefaultMedia()).volume = val / 100;
    }
    getVolume() {
        return (<VgMedia>this.vgAPI.getDefaultMedia()).volume
    }
    invokePlayConfig(data: any) {
        this.component["invokePlayConfig"](data);
    }
    get getVideoMeta() {
        var media = (<VgMedia>this.vgAPI.getDefaultMedia()).elem;
        return {
            videoWidth: media.videoWidth,
            videoHeight: media.videoHeight,
            videoRatio: media.videoWidth / media.videoHeight
        }
        // return (<VgMedia>this.vgAPI.getDefaultMedia()).elem.videoWidth / (<VgMedia>this.vgAPI.getDefaultMedia()).elem.videoHeight
    };

    setTitle(title: string) {
        this.component["media"]["title"] = title;
    }
    muted(shouldMute: boolean) {
        if (shouldMute) {
            (<VgMedia>this.vgAPI.getDefaultMedia()).volume = 0;
        }
        else {
            (<VgMedia>this.vgAPI.getDefaultMedia()).volume = 0.8;
        }
    }

    public subscriptions: Array<Subscription> = [];
    dispose(): void {
        this.subscriptions.forEach(p => p.unsubscribe());

    }
    get getPlayMedia() {
        return this.component["media"];
    }

    private vgAPI: VgAPI
    private component: Component;


    constructor() {
        //   this.vgAPI = api;
        //   this.component = component;
        // return this;
    }


    public assignData(api: VgAPI, component: Component) {
        this.vgAPI = api;
        this.component = component;
    }

    public eventList = {};

    public isPlayingAds = false;
    lastTimer = null;
    // public shouldPlaySecond = 0;
    /**
    * 订阅事件
    * @param eventName
    * @param func
    */
    public subscript(eventName: string, func) {
        var media = this.vgAPI.getDefaultMedia();
        if (!this.eventList[eventName]) {
            this.eventList[eventName] = new EventEmitter<any>();
            if (media) {

                switch (eventName) {
                    case "ended":
                        this.subscriptions.push(media.subscriptions.ended.subscribe(
                            () => {
                                //console.log(media);
                                if (media["currentPlayPos"] > 6 && !this.isPlayingAds) {
                                    this.mediaList = [];
                                    this.eventList[eventName].next(null);
                                }
                                // Set the video to the beginning
                                //this.api.getDefaultMedia().currentTime = 0;
                            }
                        ));
                        break;
                    case "time":

                        this.subscriptions.push(media.subscriptions.timeUpdate.subscribe((data) => {
                            if (!this.isPlayingAds) {
                                if (
                                    !!media.time
                                    && !!media.time["current"]
                                    && !!media.time["total"]
                                    && !isNaN(media.time["total"])
                                    && isFinite(media.time["total"])
                                    && isFinite(media.time["current"])
                                    && (!this.lastTimer ||
                                        Math.abs(media.time.current - this.lastTimer.current) > 1000)
                                ) {
                                    this.lastTimer = media.time;
                                    this.eventList[eventName].next(media.time);
                                }
                            }
                        }));


                        break;
                    case "fullscreen":
                        this.subscriptions.push(fromEvent(<any>window, VgEvents.VG_FULLSCREEN).subscribe(data => {
                            if (data && data["detail"]) {
                                this.eventList[eventName].next({
                                    isfullscreen: data["detail"]["isfullscreen"],
                                    isfake: data["detail"]["isfake"]
                                });
                            }
                            //func(data["detail"]["isfullscren"], data["detail"]["isfake"])
                        }
                            //console.log(data);
                        ));
                        break;
                    case "play":
                        this.subscriptions.push(media.subscriptions.play.subscribe((data) => {
                            if (!this.isPlayingAds)
                                this.eventList[eventName].next(media.time);// func(media.time);
                        }));
                        break;
                    case "pause":
                        this.subscriptions.push(media.subscriptions.pause.subscribe((data) => {

                            if (!this.isPlayingAds)
                                this.eventList[eventName].next(media.time);//func(media.time);
                        }));
                        break;

                    case "controlBarShow":

                        this.subscriptions.push(this.vgAPI.hiddenAPI.isHidden.subscribe(p => {
                            this.eventList[eventName].next(!p);//func(!p);
                        }));
                        break;
                    case "loadedmetadata":
                        this.subscriptions.push(media.subscriptions.loadedMetadata.subscribe(p => {
                            //console.log("sub");
                            if (!this.isPlayingAds
                                && this.getPlayMedia != null
                                && this.getPlayMedia.title != "loading")
                                this.eventList[eventName].next(!p);
                        }));
                        break;
                    case "volumechange":
                        this.subscriptions.push(media.subscriptions.volumeChange.subscribe(p => {
                            // console.log((<VgMedia>media).volume);
                            if (!this.isPlayingAds)
                                this.eventList[eventName].next(parseInt((<VgMedia>media).volume * 100 + ""));
                        }));
                        break;

                }


            }
        }


        this.subscriptions.push(this.eventList[eventName].subscribe((data) => func(data)));

        ///if(this.api.)
    }

    changeBitrate(index) {
        this.vgAPI.ss?.setBitrate(index);

    }

    captureControls() {
        this.vgAPI.hiddenAPI.captureControls();
    }
    releaseControls() {
        this.vgAPI.hiddenAPI.releaseControls();
    }
    public get isFluence() {
        return this.component["isFluence"];
    }

    private swapBackup(media) {
        if (!!media.backup) {
            var temp = media.src;
            media.src = media.backup;
            media.backup = temp;
            media.isHls = playerUtil.GetFileExtension(media.src) == ".m3u8";

        }
        return media;

    }

    public triggerPlayAds(media: IMedia) {
        if (!!this.eventList["playAds"]) {
            this.eventList["playAds"].next(media);
        }
    }
    private mediaList = [];
    private loadingMedia: IMedia =
        {

            title: "loading",
            src: "https://s1-a1.dnvodcdn.me/fast/ll.js",
            type: "video/mp4",
            length: 1,
            href: "",
            isHls: false,
            isStream: true,
            isAd: false,
            rtmp: "",
            isImage: false,
            backup: "",
            isLive: false
            //    playfirst:false
        };
    public canViewPublic = true;
    private mutipleVideoHandler(mediaList: Array<any>) {
        if (this.mediaList.length == 0
            || mediaList.length == this.mediaList.length) /// 第一次播放
        {
            this.mediaList = mediaList;
            this.component["reset"]();
            //console.log("stop");
            //this.showInfo(VideoResource.startup,5);
        }

        //var media = mediaList[0];
        this.isPlayingAds = this.component["isPlayingAds"] = true;

        this.component["skipAfter"] = 0;

        this.component["triggerCounter"](mediaList.length - 1, () => {
            //console.log("aaa");
            //media.isplayed = true;
            var medias = this.mediaList.filter(p => !p.isplayed);


            if (medias.length > 1) {
                medias[0]["isplayed"] = true;
                this.triggerPlayAds(medias[0]);
                if (this.canViewPublic) {
                    this.component["currentPlayingAds"] = this.component["media"] = medias[0];
                    this._playVideo();
                    this.component["startLoadMedia"](medias[1]);

                }
                else {
                    this.component["currentPlayingAds"] = this.component["media"] = this.loadingMedia;
                }

            }
            else {
                this.playVideo(medias, false);
            }


        })
        // console.log(media);
        // var defaultMedia = this.vgAPI.getDefaultMedia();
        // if (defaultMedia)
        // {
        //     (<VgMedia>(defaultMedia)).loadMedia();
        // }
    }



    private _playVideo() {
        var defaultMedia = this.vgAPI.getDefaultMedia();
        if (defaultMedia) {
            (<VgMedia>(defaultMedia)).pause();//.loadMedia(); // dont load
        }
    }

    public changePlayMedia(media: IMedia) {
        this.mediaList.filter(p => !p.isAd)[0] = media;
    }
    /**
     * 播放一个视频
     * @param media
     */
    public playVideo(medias: Array<IMedia>, isAds = false) {
        //console.log(medias);
        if (medias.length > 1) {
            this.mutipleVideoHandler(medias);
        }
        else if (medias.length > 0) {
            var media = medias[0];
            if (this.component["isFluence"] == false && !media.isHls) {
                this.swapBackup(media);
            }
            this.component["media"] = media;
            this.component["isPlayingAds"] = isAds;
            this._playVideo();
            if (isAds) {
                this.isPlayingAds = true;
                this.triggerPlayAds(media);
            }
            else {
                this.isPlayingAds = false;
            }
            this.component["onPlayNextVideo"](isAds);
        }
    }


    private tryDispatch(vgEvent:string)
    {
        try{
            window.dispatchEvent(new CustomEvent(vgEvent));
        }
        catch{

        }

    }
    public intersitialHandler(data: interstitialData) {
        //console.log(data)
        switch (data.event) {
            case intersitialEvent.Timer:
                //  this.caption = this.secondFormat.replace('{second}', data.data["time"]);
                break;
            case intersitialEvent.Timer+2:///需要缓存播放时间，和路径


                this.isPlayingAds = true;
                this.tryDispatch(VgEvents.VG_START_ADS);

                break;
            case intersitialEvent.ShouldBackToPlay:
                for (var i = 0; i < this.mediaList.length; ++i) {
                    if (this.mediaList[i].isAd) {
                        this.mediaList[i].isplayed = true;
                    }
                }
                //  console.log(this.mediaList.filter(p=>!p.isplayed));
                if (this.mediaList.length > 0) {
                    this.playVideo(this.mediaList.filter(p => !p.isplayed));
                }
                // console.log(this.mediaList,"should back to play");
                this.tryDispatch(VgEvents.VG_END_ADS);

                break
            case intersitialEvent.ShouldLoadAds:

                break;
            case intersitialEvent.SkipTimer:
                // this.skipAfter = data.data["time"];
                //this.leftSecond = data.data["left"];
                break;
            case intersitialEvent.ShouldCancel:
                this.tryDispatch(VgEvents.VG_END_ADS);
                break;
        }
    }

    /* */
    reset() {
        this.component["reset"]();
    }
 
    /**
     * 播放插播广告
     * @param media
     */
    invokeInterstitial(mediaList) {
        //console.log(this.component);
        this.component["invokeInterstitial"](mediaList);
    }


    invokePauseList(mediaList: any) {
        this.component["invokePauseList"](mediaList);
    }

    showInfo(info: string, hideSecond: number = 5, override = false) {
        if (!!this.component)
            this.component["showInfo"](info, hideSecond, override);
        //throw new Error("Method not implemented.");
    }


    // private getMediaAndExecute(str, param = null) {
    //     var media = (<VgMedia>this.vgAPI.getDefaultMedia());
    //     if (media != null) {
    //         if (param == null)
    //             media[str]();
    //         else {
    //             media[str](param);
    //         }
    //     }
    // }
    public play() {

        this.vgAPI.play();
        //(<VgMedia>this.vgAPI.getDefaultMedia()).play();
    }

    public pause() {
        this.vgAPI.pause();
        //(<VgMedia>this.vgAPI.getDefaultMedia()).pause();

    }


    public get currentTime() {
        return this.vgAPI && !!this.vgAPI.getDefaultMedia() ? this.vgAPI.getDefaultMedia().currentTime : 0;
    }
    public get totalTime() {
        var dd = this.vgAPI.getDefaultMedia();
        return dd != null ? dd.time["total"] || dd.duration : 0;
    }
    public getRef() {
        return this.vgAPI;
    }

    public lastSeekTime = 0;
    public seekCount = 5;
    public timeout = null;
    public seekAgain() {
        if (this.seekCount > 0) {
            if (this.timeout != null) {
                VgUtils.clearTimeout(this.timeout);
            }
            this.timeout = VgUtils.setTimeout(() => {
                // console.log("seek again ", this.lastSeekTime);
                if (this.currentTime >= this.lastSeekTime || this.lastSeekTime >= this.totalTime) {
                    this.lastSeekTime = 0;
                    this.seekCount = 5;
                }
                else {
                    this.vgAPI.seekTime(this.lastSeekTime, false);
                    this.vgAPI.getDefaultMedia().currentTime = this.lastSeekTime;
                    this.seekAgain();
                    --this.seekCount;
                }


                //this.lastSeekTime = 0;

            }, 500)
        }


    }

    public seek(time: number) {

        var second = parseInt("" + time);
        this.vgAPI.seekTime(second);
        if (second > 0) {
            this.lastSeekTime = second;
            this.seekAgain();
        }
        //  console.log("last seek time", this.lastSeekTime);
    }
}
